import React, { useState } from "react";
import { ChartLineUp, ArrowsLeftRight } from "@phosphor-icons/react";
import { ReportsTab, TransfersTab } from "@/pages/Finance";

export default function AccountsReports() {
  const [tab, setTab] = useState("reports"); // reports | transfers
  return (
    <div className="p-6 md:p-8 max-w-7xl mx-auto fade-in" data-testid="accounts-reports-page">
      <div className="flex items-center justify-between mb-6">
        <div>
          <div className="text-xs font-semibold uppercase tracking-[0.15em] text-neutral-500">Books</div>
          <h1 className="font-display text-3xl font-bold text-neutral-900 mt-1">Accounts &amp; Reports</h1>
          <div className="text-sm text-neutral-500 mt-1">Profit &amp; loss, tax position and multi-company balances</div>
        </div>
      </div>
      <div className="border-b border-neutral-200 flex gap-6 mb-6">
        <button data-testid="ar-tab-reports" onClick={() => setTab("reports")} className={`pb-3 text-sm font-medium border-b-2 transition-colors flex items-center gap-1.5 ${tab === "reports" ? "border-neutral-900 text-neutral-900" : "border-transparent text-neutral-500 hover:text-neutral-900"}`}><ChartLineUp size={14} /> Financial Reports</button>
        <button data-testid="ar-tab-transfers" onClick={() => setTab("transfers")} className={`pb-3 text-sm font-medium border-b-2 transition-colors flex items-center gap-1.5 ${tab === "transfers" ? "border-neutral-900 text-neutral-900" : "border-transparent text-neutral-500 hover:text-neutral-900"}`}><ArrowsLeftRight size={14} /> Internal Transfers</button>
      </div>
      {tab === "reports" && <ReportsTab />}
      {tab === "transfers" && <TransfersTab />}
    </div>
  );
}
